
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDragVertical as ObiDragVerticalElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-drag-vertical.js';
 
 
 

 
 export const ObiDragVertical = createComponent({
   react: React,
   tagName: 'obi-drag-vertical',
   elementClass: ObiDragVerticalElement,
   events: {
     
   }
  });
 
 